
import { Pipe, PipeTransform } from '@angular/core';
import { padStart } from 'lodash';
import moment from 'moment';

@Pipe({
    name: 'durationString',
    standalone: false
})
export class DurationStringPipe implements PipeTransform {
  transform(totalSeconds: number, showSeconds = false): string {
    const duration = moment.duration(+totalSeconds * 1000);
    const paddedHours = padStart(Math.floor(duration.as('h')).toString(), 2, '0');
    const minutes = moment.utc(duration.as('ms')).format('mm');
    const seconds = moment.utc(duration.as('ms')).format('ss');

    return paddedHours + 'h ' + minutes + 'm ' + (showSeconds ? seconds + 's ' : '');
  }
}
